import React from 'react'
import styles from './dsNotifications.jcss'
import translate from '../../core/translate'
import Content from 'blocks.app/content/content'
import { Units } from './__units/Units'

export const DSNotifications = () => {
    return (
        <Content title={translate('DSNotifications')} wrapperClassName={styles.notificationsComponent}>
            <Units />
        </Content>
    )
}
